
import Hero from './components/Hero';
import Services from './components/Services';
import About from './components/About';
import Projects from './components/Projects';
import Testimonials from './components/Testimonials';
import CTA from './components/CTA';
import Footer from './components/Footer';
import Navbar from './components/Navbar';
import CookieBanner from '../../components/CookieBanner';
import WhatsAppPopup from '../../components/WhatsAppPopup';
import WhatsAppButton from '../../components/WhatsAppButton';
import ContactForm from './components/ContactForm';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <Services />
      <About />
      <Projects />
      <Testimonials />
      <CTA />
      <Footer />
      <CookieBanner />
      <WhatsAppPopup />
      <WhatsAppButton />
      <ContactForm />
    </div>
  );
}
